import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type UploadProgressStatus = 'uploading' | 'success'

type State = {
  visible: boolean
  status: UploadProgressStatus
  uploaded: number
  total: number
}

const initialState: State = {
  visible: false,
  status: 'uploading',
  uploaded: 0,
  total: 0,
}

const { actions, reducer } = createSlice({
  name: 'upload_progress',
  initialState,
  reducers: {
    startUpload: (state, action: PayloadAction<{ total: number }>) => {
      state.visible = true
      state.status = 'uploading'
      state.uploaded = 0
      state.total = action.payload.total
    },
    incrementUploaded: (state) => {
      state.uploaded += 1
    },
    completeUpload: (state) => {
      state.status = 'success'
    },
    hideUploadProgress: (state) => {
      state.visible = false
    },
  },
})

export { reducer }
export default actions
